import { render } from "./ModifyAccount.vue?vue&type=template&id=ff5e4048&scoped=true"
import script from "./ModifyAccount.vue?vue&type=script&lang=js"
export * from "./ModifyAccount.vue?vue&type=script&lang=js"

import "./ModifyAccount.vue?vue&type=style&index=0&id=ff5e4048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5e4048"],['__file',"src/components/auth/ModifyAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff5e4048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff5e4048', __exports__)) {
    api.reload('ff5e4048', __exports__)
  }
  
  module.hot.accept("./ModifyAccount.vue?vue&type=template&id=ff5e4048&scoped=true", () => {
    api.rerender('ff5e4048', render)
  })

}


export default __exports__